// @flow
import moment from '@seek/moment-timezone-sydney';

export const isCampaignActive = ({
  from,
  to
}: {
  from?: string,
  to?: string
}) => {
  /*
  // from - campaign start date inclusive
  // to - campaign end date inclusive
  */
  const now = moment().tz('Australia/Sydney');
  const startDate = moment(from).tz('Australia/Sydney');
  const endDate = moment(to).tz('Australia/Sydney');

  return (
    (from ? now.isAfter(startDate) : true) &&
    (to ? now.isBefore(endDate) : true)
  );
};
